import React from 'react';

import { appConfig as $config } from '../app.config';
import { UI } from './UI';
import { App } from './App';
import { WS } from './WS';
import { Legal } from '../pages/Legal';

export const User = (function () {
  const userStorKeys = {
    UserIDKey: $config.storagekey.userID,
    UserDataKey: $config.storagekey.userdata, // bbw_userdata
    UserAccountKey: $config.storagekey.accountdata, // bbw_accountdata
    UserAccountsKey: $config.storagekey.accountsdata, // bbw_accountsdata
    UserAuthKey: $config.storagekey.userauth,
    UserCurrAccIDKey: $config.storagekey.currentAccountID,
    UserSelectAccountId: $config.storagekey.selectaccountid,
    UserContextKey: $config.storagekey.userContext,
    UserIsLicensor: $config.storagekey.isLicensor,
    UserSelectedLicensors: $config.storagekey.selectedLicensors
  };

  let mapping = {
    userdata: (data) => {
      return {
        isFirstLogin: data.isFirstLogin || false,
        token: data.token,
        role: data.role,
        lastLoginDate: data.lastLoginDate,
        email: data.email
      };
    },
    userauth: (data) => {
      return data.token;
    },
    userAccounts: (data) => {
      data.accounts.forEach((parentAccount) => {
        parentAccount.subAccounts.forEach((acc) => {
          acc.parentName = parentAccount.name;
          acc.parentId = parentAccount.id;
        });
      });
      return data.accounts;
    },
    userContext: (data) => {
      if (!data.user) {
        return null;
      }

      let user = data.user;
      let userContext = {
        name: user.displayName,
        email: user.email,
        accountType: user.accounts[0].accountTypeName,
        accountName: user.accounts[0].name,
        canChangeAccount: user.canChangeAccount,
        parentAccount: user.accounts.length ? user.accounts[0] : {}
      };
      return userContext;
    },
    userAccount: (data) => {
      return data.accounts[0];
    }
  };

  let ID = () => {
    return $storage.get(userStorKeys.UserIDKey);
  };

  let isAdminFantec = () => {
    return $config.fantecAdmin.includes(ID());
  };

  let data = () => {
    return $storage.get(userStorKeys.UserDataKey);
  };

  let accountID = () => {
    return $storage.get(userStorKeys.UserSelectAccountId);
  };

  let licensorsId = () => {
    return $storage.get(userStorKeys.UserSelectedLicensors);
  };

  let setLicensorsId = (data = []) => {
    $storage.set(userStorKeys.UserSelectedLicensors, data);
  };

  let isLicensor = () => {
    return $storage.get(userStorKeys.UserIsLicensor);
  };

  let accountData = () => {
    return $storage.get(userStorKeys.UserAccountKey);
  };

  let accountsData = () => {
    return $storage.get(userStorKeys.UserAccountsKey);
  };

  let isUser = () => {
    if ($storage.isSet(userStorKeys.UserDataKey) && !$storage.isEmpty(userStorKeys.UserDataKey)) {
      return true;
    }
    return false;
  };

  let userContext = () => {
    return $storage.get(userStorKeys.UserContextKey);
  };

  let signin = (formData) => {
    $.when(App.ajaxData('users/login', formData, 'POST')).done((res) => {
      if (!res.isSuccess) {
        UI.btn.spinnerStopAll();
        return UI.alert.inForm(res.errorInformation.errorReason, form);
      }

      let userFirstData = {
        IDKey: formData.user,
        DataKey: mapping.userdata(res),
        AuthKey: mapping.userauth(res)
      };

      // Collapse Side menu
      UI.asideToggleOn();

      if (res.isFirstLogin) {
        Legal.dialog()
          .then(() => {
            cookieHandler(userFirstData);
          })
          .catch(signout);
      } else {
        cookieHandler(userFirstData);
      }
    });
  };

  let authorizeUser = () => {
    App.ajaxData('accounts/myAccounts').then((res) => {
      UI.btn.spinnerStopAll();
      if (!res.user) {
        return UI.errorMessage('User not found!');
      }

      storeUserAccounts(res);

      authorizedHandler();
    });
  };

  let cookieHandler = (userFirstData) => {
    let cook = Cookies.get('bbw_account_cookie');
    if (!cook) {
      Legal.dialog('CP')
        .then((res) => {
          Cookies.set('bbw_account_cookie', 1, { expires: 365 });
          storeUserFirstData(userFirstData);
          authorizeUser();
        })
        .catch(signout);
    } else {
      storeUserFirstData(userFirstData);
      authorizeUser();
    }
  };

  let signout = () => {
    UI.btn.spinnerStopAll();

    let handlePageLeave = UI.handlePageLeaveActive('/login', unauthorizedHandler);

    if (!handlePageLeave) {
      unauthorizedHandler();
    }
  };

  let unauthorizedHandler = () => {
    // Remove all storage saved data
    $storage.removeAll();
    WS.destroy();
    //$router.forceNavigate('/login');
    $router.push('/login');
    document.location.reload();
  };

  let authorizedHandler = () => {
    //document.location.reload();
    // WS.init();
    //$router.forceNavigate('/');
    $router.push('/');
  };

  let storeUserAccounts = (data) => {
    let userAccountsResult = mapping.userAccounts(data);
    let userContext = mapping.userContext(data);
    $storage.set(userStorKeys.UserAccountsKey, userAccountsResult);
    $storage.set(userStorKeys.UserContextKey, userContext);

    setAccount(userAccountsResult);
  };

  let storeUserFirstData = (data) => {
    $storage.set(userStorKeys.UserIDKey, data.IDKey);
    $storage.set(userStorKeys.UserDataKey, data.DataKey);
    $storage.set(userStorKeys.UserAuthKey, data.AuthKey);
  };

  let setAccount = (data = false, accountID = false) => {
    let accountsData = data || $storage.get(userStorKeys.UserAccountsKey),
      userContextData = userContext() || {};

    let currAccData = accountsData[0]?.subAccounts[0] || {};

    // Check cookies saved Account ID
    let cookiesid = Cookies.get('bbw_account_id');

    let currentAccountID;

    if (accountID) {
      currentAccountID = accountID;
    } else if (cookiesid) {
      currentAccountID = cookiesid;
      //Cookies.remove('bbw_account_id');
    } else {
      currentAccountID = accountsData[0].subAccounts[0].id;
    }

    accountsData.forEach((parAcc) => {
      parAcc.subAccounts.forEach((acc) => {
        if (acc.id === currentAccountID) {
          currAccData = acc;
        }
      });
    });

    $storage.set(userStorKeys.UserCurrAccIDKey, currAccData.id);

    $storage.set(userStorKeys.UserAccountKey, currAccData);
    App.pageData('ACNT', currAccData);

    userContextData.parentAccount = accountsData.filter((parAcc) => parAcc.id === currAccData.parentId)[0];
    $storage.set(userStorKeys.UserContextKey, userContextData);
    App.pageData('userdata', userContextData);

    return currAccData;
  };

  let selectAccount = (accountID, redirect = false) => {
    let handlePageLeave = UI.handlePageLeaveActive('', () => {
      setAccount(false, accountID);
      setAccountReload(redirect);
    });

    if (!handlePageLeave) {
      setAccount(false, accountID);
      setAccountReload(redirect);
    }
  };

  // - Per Page selected accaounts
  let selectedAccounts = {
    store: (page) => {
      page = page.toLowerCase();
      let parentAccount = App.pageData(`ACNT.${page}ParentAccount`);
      let Account = App.pageData(`ACNT.${page}Account`);

      // Store selected Accounts
      $storage.set(`bbw_${page}page_selectedaccounts`, {
        parentAccount: parentAccount.id ? parentAccount : null,
        Account: Account.id ? Account : null
      });
    },
    get: (page) => {
      page = page.toLowerCase();
      let parentAccount = App.pageData(`ACNT.${page}ParentAccount`) || null;
      let Account = App.pageData(`ACNT.${page}Account`) || null;

      return {
        accountId: Account?.id ? Account.id : parentAccount?.id ? parentAccount.id : '',
      };
    },
    restore: (page) => {
      page = page.toLowerCase();

      const selectedaccounts = $storage.get(`bbw_${page}page_selectedaccounts`);

      if (selectedaccounts) {
        App.pageData(`ACNT.${page}Account`, selectedaccounts.Account);
        App.pageData(`ACNT.${page}ParentAccount`, selectedaccounts.parentAccount);
      }
    },
    clear: (page, clearParent = false, clearSub = false) => {
      page = page.toLowerCase();

      if (clearParent && App.pageData(`ACNT.${page}ParentAccount`)) {
        App.pageData(`ACNT.${page}ParentAccount`, 'clear');
      }

      if (clearSub && App.pageData(`ACNT.${page}Account`)) {
        App.pageData(`ACNT.${page}Account`, 'clear');
      }
    }
  };

  let selectAllAccount = () => {
    $storage.set(userStorKeys.UserCurrAccIDKey, '');
    $storage.set(userStorKeys.UserAccountKey, '');
    setAccountReload();
  };

  let setAccountReload = (redirect = false) => {
    window.dispatchEvent(new Event('accountreload:start'));

    let pageurl = document.location.pathname.split('/')[1] || '';
    App.pageDataInit(null, true);

    // WS.destroy();
    // WS.init();

    // Return router handler IF disabled
    //$router.pause(false);
    if (redirect) $router.push(redirect);
    else $router.push('/' + pageurl);

    window.dispatchEvent(new Event('accountreload:complete'));
  };

  return {
    ID,
    data,
    accountData,
    accountsData,
    accountID,
    licensorsId,
    setLicensorsId,
    isLicensor,
    isUser,
    userContext,
    unauthorizedHandler,
    signin,
    signout,
    storeUserAccounts,
    setAccount,
    selectAccount,
    selectedAccounts,
    selectAllAccount,
    setAccountReload,
    isAdminFantec
  };
})();
